<template>
  <v-form ref="form" @submit.prevent="onCreateExport">
    <v-card tile>
      <v-card-title class="grey lighten-2">Kvalitetsrapport</v-card-title>

      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="12">
            <v-menu
              :close-on-content-click="false"
              v-model="menu"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  v-model="dateRangeText"
                  label="Period"
                  outlined
                  readonly
                  :error-messages="
                    period.length !== 2 ? 'Måste välja 2 datum' : null
                  "
                />
              </template>
              <v-date-picker
                locale="sv"
                range
                first-day-of-week="1"
                v-model="period"
                no-title
              >
                <v-spacer></v-spacer>
                <v-btn text @click="menu = false">
                  Stäng
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="onClose" :disabled="loading">Avbryt</v-btn>
        <v-btn
          rounded
          type="submit"
          color="primary"
          :loading="loading"
          :disabled="period.length !== 2"
          >Hämta</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { format, addDays } from 'date-fns'
import orderBy from 'lodash.orderby'
import {
  queryUnhandledTrainDeviations,
  queryUnhandledDelays
} from '@/modules/linkDeviation/store'

import { generateAndDownloadQualityReport } from './exportGenerator'

export default {
  name: 'QualityReport',

  data() {
    return {
      menu: false,
      loading: false,
      period: [
        format(addDays(new Date(), -1), 'yyyy-MM-dd'),
        format(new Date(), 'yyyy-MM-dd')
      ]
    }
  },

  computed: {
    dateRangeText() {
      return `${this.orderedPeriod[0] || ''} ~ ${this.orderedPeriod[1] || ''}`
    },

    orderedPeriod() {
      return orderBy(this.period, [x => x], ['asc'])
    }
  },

  methods: {
    async onCreateExport() {
      this.loading = true
      const fileName = `Kvalitetsrapport ${this.dateRangeText}`

      const district_id = this.$store.get('app/selectedDistrictId')
      const from = this.orderedPeriod[0]
      const to = this.orderedPeriod[1]

      const filter = {
        district_id,
        to,
        from
      }

      const [trainDeviations, unhandledDelays] = await Promise.all([
        queryUnhandledTrainDeviations(filter),
        queryUnhandledDelays(filter)
      ])

      const pluckDelayType1 = x => ({
        Datum: x.departure_date || null,
        Turnr: x.train_number || null,
        Mätpunkt: x.location_place || null,
        Avvikelsetid: x.delay_minutes || null,
        Orsak: x.delay_reason_description || null,
        Orsakskategori: null,
        Operatörsberoende: null,
        'Skadenr Ford': null
      })

      const pluckDelayType2 = x => ({
        Datum: x.departure_date || null,
        Turnr: x.train_number || null,
        Sträcka: null,
        Ankomststation: x.delay_place || null,
        Avvikelsetid: x.delay_minutes || null,
        Orsak: x.delay_reason_description || null,
        Orsakskategori: null,
        Operatörsberoende: null,
        Förstärkningstrafik: null,
        ÖDOC: x.odoc || null,
        'Skadenr Ford': null
      })

      const pluckDeviation = x => ({
        Datum: x.departure || null,
        Turnr: x.train_number || null,
        Sträcka: x.from && x.to ? `${x.from}-${x.to}` : null,
        'Hel-/delinställd': x.deviation_type
          ? x.deviation_type === 'PARTIAL_CANCELLATION'
            ? 'Delinställd'
            : 'Helinställd'
          : null,
        Avvikelsekm: null,
        Orsak: null,
        Orsakskategori: null,
        Operatörsberoende: null,
        'Ersättnings-trafik': null,
        Ersättningstrafik: null,
        ÖDOC: x.odoc || null,
        'Typ 2 eller typ3': null,
        'Skadenr Ford': null
      })

      const unhandledDelaysType1 = unhandledDelays.filter(
        x => x.delay_minutes <= 20
      )

      const unhandledDelaysType2 = unhandledDelays.filter(
        x => x.delay_minutes > 20
      )

      await generateAndDownloadQualityReport(fileName, {
        name: fileName,
        sheets: [
          {
            name: 'Försenad Tur, 3-20 min',
            data: unhandledDelaysType1.length
              ? unhandledDelaysType1.map(pluckDelayType1)
              : [{}].map(pluckDelayType1)
          },
          {
            name: 'Inställd Tur, typ 1',
            data: unhandledDelaysType2.length
              ? unhandledDelaysType2.map(pluckDelayType2)
              : [{}].map(pluckDelayType2)
          },
          {
            name: 'Inställd Tur, typ 2 och 3',
            data: trainDeviations.length
              ? trainDeviations
                  .filter(x =>
                    ['PARTIAL_CANCELLATION', 'CANCELED'].includes(
                      x.deviation_type
                    )
                  )
                  .map(pluckDeviation)
              : [{}].map(pluckDeviation)
          }
        ]
      })
      this.loading = false
      this.onClose()
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>
